import {Argument} from '@app/core/model/filtering/argument';
import {PropertyFilterModel} from '@app/core/model/filtering/property-filter-model';
import {RequestedFilterViewModel} from '@app/core/model/integration-models';
import {FilterPredicate} from '@app/core/model/filtering/filter-predicate';

export enum FilterState {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}

export enum FilterAction {
    VALIDATE_AND_REPORT = 'VALIDATE_AND_REPORT',
    VALIDATE_AND_SKIP = 'VALIDATE_AND_SKIP',
    VALIDATE_AND_TERMINATE = 'VALIDATE_AND_TERMINATE',
    ALLOW = 'ALLOW',
    DENY = 'DENY',
    STREAM_TRANSFORM = 'STREAM_TRANSFORM',
    TRANSFORM = 'TRANSFORM'
}

export class EntityFilterModel {
    filterIndex?: number;

    constructor(
        public taskId: string = null,
        public action: FilterAction = null,
        public propertyFilters: Array<PropertyFilterModel> = <PropertyFilterModel[]>[],
        public state: FilterState = FilterState.ACTIVE,
        public entityFilterId: string = null,
        public linkedEntityTypes: Array<string> = <string[]>[],
        public isMyFilter: boolean = true,
        public isSystemFilter: boolean = false,
        public priority: number = null,
        public ownerGuid: string = null,
        public customValues: Map<string, Argument> = null,
        public isMapping: boolean = false
    ) {
    }

    static getPropertyFiltersHash(entityFilter: EntityFilterModel): string {
        return entityFilter.propertyFilters
            .map((propertyFilter: PropertyFilterModel) => PropertyFilterModel.toString(propertyFilter))
            .join();
    }

    static getCustomValuesHash(entityFilter: EntityFilterModel): string {
        const customValues: string[] = [];
        entityFilter.customValues
            .forEach((value: Argument, key: string) =>
                customValues.push(key + JSON.stringify(value))
            );
        return entityFilter.taskId + customValues.sort().join();
    }
}

export interface FiltrationsBySchool {
    'ids': string[];
    'names': string[];
    'schoolNames': string[];
    'schoolGuids': string[];
    'filtersList': RequestedFilterViewModel[];
}

export interface FiltrationsBySchools {
    string: FiltrationsBySchool;
}

export interface FiltrationsByEntity {
    string: RequestedFilterViewModel[];
}

export interface EntityFilter {
    'entityName': string;
    'selected': boolean;
}

export class ExtraAttribute {
    constructor(
        public propertyName: string,
        public requiredEntity: string,
        public predicate: FilterPredicate
    ) {
    }
}

export const TASK_EXTRA_ATTRIBUTES = {
    'Student': [
        new ExtraAttribute('rosters', 'Roster', FilterPredicate.IS_ROSTERS_EMPTY)
    ],
    'Staff': [
        new ExtraAttribute('rosters', 'Roster', FilterPredicate.IS_ROSTERS_EMPTY)
    ],
    'Roster': [
        new ExtraAttribute('students', 'Student', FilterPredicate.IS_STUDENTS_NOT_EXIST)
    ]
};
